var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "main-menu menu-fixed menu-accordion menu-shadow",
    class: [{
      'expanded': !_vm.isVerticalMenuCollapsed || _vm.isVerticalMenuCollapsed && _vm.isMouseHovered
    }, _vm.skin === 'semi-dark' ? 'menu-dark' : 'menu-light'],
    on: {
      "mouseenter": function mouseenter($event) {
        return _vm.updateMouseHovered(true);
      },
      "mouseleave": function mouseleave($event) {
        return _vm.updateMouseHovered(false);
      }
    }
  }, [_c('div', {
    staticClass: "navbar-header expanded",
    style: _vm.isAdminGudang && !_vm.isSales ? {
      height: '6.5rem'
    } : {
      height: '4.45rem'
    }
  }, [_vm._t("header", [_c('section', {
    staticClass: "border-bottom"
  }, [_c('ul', {
    staticClass: "nav navbar-nav flex-row"
  }, [_c('li', {
    staticClass: "nav-item mr-auto"
  }, [_c('b-link', {
    staticClass: "navbar-brand",
    attrs: {
      "to": "/"
    }
  }, [_c('span', {
    staticClass: "brand-logo"
  }, [_c('b-img', {
    attrs: {
      "src": "/assets/logo-96.png",
      "alt": "logo"
    }
  })], 1), _c('h2', {
    staticClass: "brand-text"
  }, [_vm._v(" " + _vm._s(_vm.appName) + " ")])])], 1), _c('li', {
    staticClass: "nav-item nav-toggle"
  }, [_c('b-link', {
    staticClass: "nav-link modern-nav-toggle"
  }, [_c('feather-icon', {
    staticClass: "d-block d-xl-none",
    attrs: {
      "icon": "XIcon",
      "size": "20"
    },
    on: {
      "click": _vm.toggleVerticalMenuActive
    }
  }), _c('feather-icon', {
    staticClass: "d-none d-xl-block collapse-toggle-icon",
    attrs: {
      "icon": _vm.collapseTogglerIconFeather,
      "size": "20"
    },
    on: {
      "click": _vm.toggleCollapsed
    }
  })], 1)], 1)]), _vm.isAdminGudang && !_vm.isSales || _vm.isAdminAsset ? _c('ul', {
    staticClass: "nav navbar-nav"
  }, [_c('li', {
    staticClass: "nav-item ml-1"
  }, [_c('div', {
    staticClass: "d-flex align-items-center"
  }, [_c('h5', [_c('strong', [_vm._v(_vm._s(this.myGudang.nama_gudang))])])])])]) : _vm._e()])], {
    "toggleVerticalMenuActive": _vm.toggleVerticalMenuActive,
    "toggleCollapsed": _vm.toggleCollapsed,
    "collapseTogglerIcon": _vm.collapseTogglerIcon
  })], 2), _c('div', {
    staticClass: "shadow-bottom",
    class: {
      'd-block': _vm.shallShadowBottom
    }
  }), _c('vue-perfect-scrollbar', {
    staticClass: "main-menu-content scroll-area",
    attrs: {
      "settings": _vm.perfectScrollbarSettings,
      "tagname": "ul"
    },
    on: {
      "ps-scroll-y": function psScrollY(evt) {
        _vm.shallShadowBottom = evt.srcElement.scrollTop > 0;
      }
    }
  }, [_c('vertical-nav-menu-items', {
    staticClass: "navigation navigation-main",
    attrs: {
      "items": _vm.myMenus
    }
  })], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }